module.exports = __webpack_public_path__ + "media/newstyle/images/publish-book_agbook-2-d71de17789b28a51433131b215ad1a47.png";